// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import jquery from 'jquery';
import axios from 'axios';
import store from 'store';
import 'tippy.js';
import 'bootstrap';
import Multiselect from 'vue-multiselect';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import VueContentLoading from 'vue-content-loading';
import toastr from 'toastr';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import ReadMore from 'vue-read-more';
/* import moment from 'moment'; */

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import StarRating from 'vue-star-rating';

// eslint-disable-next-line
import Echo from 'laravel-echo';
import VueFuse from 'vue-fuse';
import VueClipboard from 'vue-clipboard2';

// eslint-disable-next-line
import VScrollLock from 'v-scroll-lock';
// eslint-disable-next-line camelcase
import $_can from './components/mixins/can';
// eslint-disable-next-line camelcase
import $_checkProperties from './components/mixins/checkProperties';
import SimpleSelect from './components/SimpleSelect';
import KeyMultiselect from './components/KeyMultiSelect';
import vuexStore from './store/store';
import router from './router';
import App from './App';
import ErrorField from './components/ErrorField';
import './includes/vue-directives';

Vue.config.productionTip = false;
/* Vue.prototype.moment = moment; */
window.Pusher = require('pusher-js');

// Load jquery
window.$ = jquery;
window.jQuery = jquery;
window.axios = axios;

window.toastr = require('toastr');

toastr.options.positionClass = 'toast-top-center';

if (process.env.USE_PUSHER === 'true') {
  window.echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.PUSHER_APP_KEY,
    cluster: process.env.PUSHER_APP_CLUSTER,
    authEndpoint: process.env.BROADCASTING_AUTH_URL,
    encrypted: false,
  });
} else {
  window.echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.ECHO_APP_KEY,
    wsHost: process.env.ECHO_HOST,
    authEndpoint: process.env.BROADCASTING_AUTH_URL,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
  });
}
window.axios.defaults.baseURL = process.env.API_URL;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common.Authorization = `Bearer ${store.get('jwtToken')}`;
window.axios.defaults.params = {};

Vue.component('key-multiselect', KeyMultiselect);
Vue.component('multiselect', Multiselect);
Vue.component('simple-select', SimpleSelect);
Vue.component('clip-loader', ClipLoader);
Vue.component('vue-content-loading', VueContentLoading);
Vue.component('error-field', ErrorField);
Vue.use(VueDOMPurifyHTML);
Vue.use(ReadMore);
Vue.use(VueFuse);
Vue.use(VueClipboard);
Vue.use(VScrollLock);
Vue.mixin($_can);
Vue.mixin($_checkProperties);
Vue.use(VueSweetalert2);
Vue.component('star-rating', StarRating);

/* eslint-disable no-unused-vars */
const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: vuexStore,
});

window.axios.interceptors.request.use(config => {
  return config;
});

window.axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const code = error.response ? error.response.status : null;
    switch (code) {
      case 401:
        store.remove('dispatchUser');
        store.remove('jwtToken');
        router.push('/login');
        break;
      // case 403:
      //   toastr.error('Authorisation error occurred')
      //   break
      case 500:
        toastr.error('Server returned an error');
        break;
      default:
        break;
      // toastr.error('Unknown error occurred');
    }
    return Promise.reject(error);
  },
);



// WEBPACK FOOTER //
// ./src/main.js